import { Box, Flex, Image, Text } from '@cmpsr/components';
import React from 'react';

/**
 * A mini social proof component showing user testimonial with performance stats
 */
export interface SocialProofMiniProps {
  name: string;
  imageSrc: string;
  percentage: number;
  graphKey?: number;
}

const TOTAL_GRAPH_VARIANTS = 8;

const SocialProofMini: React.FC<SocialProofMiniProps> = ({ name, imageSrc, percentage, graphKey = 0 }) => {
  // Map the key to a graph variant (1-8) using modulo
  const graphVariant = (Math.abs(graphKey) % TOTAL_GRAPH_VARIANTS) + 1;

  return (
    <Flex
      width={{ base: '261.095px', lg: '365px' }}
      padding={{ base: '17.17px', lg: '24px' }}
      borderRadius="16px"
      backgroundColor="white"
      borderColor="neutral"
      borderWidth="1px"
      flexDirection="column"
      gap="spacer-2"
      boxShadow="0px 4px 44px 0px rgba(0, 0, 0, 0.15)"
    >
      <Flex alignItems="center" gap="spacer-4">
        <Flex alignItems="center" gap="spacer-4">
          <Image
            src={imageSrc}
            alt={`${name}'s profile`}
            width={{ base: '45.781px', lg: '64px' }}
            height={{ base: '45.781px', lg: '64px' }}
            borderRadius="5px"
            objectFit="cover"
          />

          <Flex flexDirection="column" gap="spacer-1">
            <Flex alignItems="center" gap="spacer-4">
              <Flex
                alignItems="center"
                justifyContent="center"
                backgroundColor="green-300"
                borderRadius="5px"
                width="30px"
                height="30px"
              >
                <Image src="/images/green-down-arrow.svg" alt="Up arrow" width="30px" height="30px" />
              </Flex>
              <Text
                fontFamily="Libre Baskerville"
                fontSize={{ base: '17.168px', lg: '24px' }}
                color="navy-800"
                lineHeight="1em"
              >
                {percentage.toFixed(1)}%
              </Text>
            </Flex>
            <Text fontSize={{ base: '14.307px', lg: '20px' }} lineHeight="1.3em" color="black" fontWeight={700}>
              {name}
            </Text>
          </Flex>
        </Flex>

        <Box flexGrow={1} />

        <Image
          src={`/images/graphs/graph-${graphVariant}.svg`}
          alt={`Performance graph ${graphVariant}`}
          width={{ base: '71.533px', lg: '100px' }}
        />
      </Flex>
    </Flex>
  );
};

export default SocialProofMini;
